var map = {
	"./Checked.png": 80,
	"./back.png": 67,
	"./couronne.png": 66,
	"./launch_btn.png": 35,
	"./tete1.png": 98,
	"./tete10.png": 99,
	"./tete11.png": 100,
	"./tete12.png": 101,
	"./tete13.png": 102,
	"./tete14.png": 103,
	"./tete15.png": 104,
	"./tete16.png": 105,
	"./tete17.png": 106,
	"./tete18.png": 107,
	"./tete19.png": 108,
	"./tete2.png": 109,
	"./tete20.png": 110,
	"./tete21.png": 111,
	"./tete22.png": 112,
	"./tete23.png": 113,
	"./tete24.png": 114,
	"./tete25.png": 115,
	"./tete26.png": 116,
	"./tete27.png": 117,
	"./tete28.png": 118,
	"./tete29.png": 119,
	"./tete3.png": 120,
	"./tete30.png": 121,
	"./tete31.png": 122,
	"./tete32.png": 123,
	"./tete33.png": 124,
	"./tete34.png": 125,
	"./tete35.png": 126,
	"./tete36.png": 127,
	"./tete37.png": 128,
	"./tete38.png": 129,
	"./tete39.png": 130,
	"./tete4.png": 131,
	"./tete40.png": 132,
	"./tete41.png": 133,
	"./tete42.png": 134,
	"./tete43.png": 135,
	"./tete44.png": 136,
	"./tete45.png": 137,
	"./tete46.png": 138,
	"./tete47.png": 139,
	"./tete48.png": 140,
	"./tete49.png": 141,
	"./tete5.png": 142,
	"./tete50.png": 143,
	"./tete51.png": 144,
	"./tete52.png": 145,
	"./tete53.png": 146,
	"./tete54.png": 147,
	"./tete55.png": 148,
	"./tete56.png": 149,
	"./tete57.png": 150,
	"./tete58.png": 151,
	"./tete59.png": 152,
	"./tete6.png": 153,
	"./tete60.png": 154,
	"./tete61.png": 155,
	"./tete62.png": 156,
	"./tete63.png": 157,
	"./tete64.png": 158,
	"./tete65.png": 159,
	"./tete66.png": 160,
	"./tete67.png": 161,
	"./tete68.png": 162,
	"./tete69.png": 163,
	"./tete7.png": 164,
	"./tete70.png": 165,
	"./tete71.png": 166,
	"./tete72.png": 167,
	"./tete73.png": 168,
	"./tete74.png": 169,
	"./tete75.png": 170,
	"./tete76.png": 171,
	"./tete77.png": 172,
	"./tete78.png": 173,
	"./tete79.png": 174,
	"./tete8.png": 175,
	"./tete80.png": 176,
	"./tete81.png": 177,
	"./tete82.png": 178,
	"./tete83.png": 179,
	"./tete84.png": 180,
	"./tete85.png": 181,
	"./tete86.png": 182,
	"./tete87.png": 183,
	"./tete88.png": 184,
	"./tete89.png": 185,
	"./tete9.png": 186,
	"./tete90.png": 187,
	"./tete91.png": 188,
	"./tete92.png": 189,
	"./tete93.png": 190,
	"./tete94.png": 191,
	"./tete95.png": 192,
	"./tete96.png": 193,
	"./tete97.png": 194,
	"./tete98.png": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;